<template lang="html">
  <div class="loyalty-points-section">
    <div class="medium-12 columns">
      <h1 class="page-header text-center">reports: loyalty points</h1>
    </div>

    <div class="medium-12 columns">
      <div class="data-title text-center timeframe-title">analyze change within timeframe</div>
    </div>

    <date-range
      v-for="(timeframe, index) in timeframes"
      :key="index"
      :id="index"
      :fr="timeframe.from"
      :to="timeframe.to"
      @onRemove="removeTimeframe"
      @onUpdate="update"
    />

    <div class="row columns center-button">
      <input type="submit" :disabled="!validRange || state.isSending"
             value="analyze"
             :class="['button larger']"
             id="analyze-button"
             @click.prevent="submit">
    </div>

    <div class="text-right data-title" v-if="this.timeframes.length <= 9">
      <span class="add-timeframe-link" @click="addTimeframe">+ add timeframe</span>
    </div>

    <div class="divider"></div>

    <span class="error-label" v-if="errors.message">{{ errors.message }}</span>

    <transaction-results-details
      v-for="(record, index) in records"
      :key="index + '-record'"
      :records="record"
    />
  </div>
</template>

<script>
import axiosConfig from '../../packs/axios'
import { mapGetters, mapState } from 'vuex'
import DateRange from '../components/LoyaltyPoints/DateRange'
import TransactionResultsDetails from '../components/LoyaltyPoints/TransactionResultsDetails'
import moment from 'moment-timezone'

export default {
  name: 'LoyaltyPoints',

  components: {
    DateRange,
    TransactionResultsDetails,
  },

  data() {
    return {
      from: '',
      to: '',
      errors: {},
      validRange: true,
      timeframes: [],
      records: [],
      state: {
        isSending: false
      }
    }
  },

  methods: {
    addTimeframe() {
      if (this.timeframes.length <= 9) {
        this.timeframes.push({
          from: this.from,
          to: this.to,
          isValid: true,
        })
      }
    },

    fetchRecords(params) {
      const url = `/api/v3/loyalty_points`
      let data
      this.state.isSending = true;

      return axiosConfig.get(url, params).then((response) => {
        data = response.data
        if (data) {
          this.state.isSending = false;
          return data
        } else {
          this.errors.message = 'there is no data response with provided date range.'
        }
      }).catch((error) => {
        this.errors.message = `there is an api issue: ${error}`
      })
    },

    removeTimeframe(index) {
      this.timeframes.splice(index, 1)

      if (this.records.length >= this.timeframes.length) {
        this.records.splice(index, 1)
      }
    },

    submit() {
      let promised = []
      let responded = []

      this.timeframes.forEach(timeframe => {
        let from = moment(timeframe.from, 'MM-D-Y 00:00:00 UTC')
        let to = moment(timeframe.to, 'MM-D-Y 23:59:59 UTC')
        from = moment.utc([from.year(), from.month(), from.date()]).unix()
        to = moment.utc([to.year(), to.month(), to.date(), 23, 59, 59]).unix()
        let params = { params: { from: from, to: to } }
        promised.push(this.fetchRecords(params))
      })

      Promise.all(promised).then(values => {
        values.forEach(value => {
          responded.push(value)
        })
      })

      this.records = responded
    },

    update(values) {
      this.timeframes[values.id].from = values.from
      this.timeframes[values.id].to = values.to
      this.timeframes[values.id].isValid = values.isValid
      this.validRange = values.isValid
    },
  },

  created() {
    this.$store.dispatch('LOAD_CURRENT_MERCHANT')
  },

  computed: {
    ...mapState([
      'currentMerchant'
    ]),
  },

  watch: {
    currentMerchant: function() {
      if (this.currentMerchant) {
        this.from = moment.tz(moment().subtract(1, 'months'), this.currentMerchant.merchant_time_zone).format('MM-D-Y HH:mm:ss')
        this.to = moment.tz(moment(), this.currentMerchant.merchant_time_zone).format('MM-D-Y HH:mm:ss')
        this.addTimeframe()
      }
    },

    timeframes: function() {
      let isValid = true
      this.timeframes.forEach(timeframe => {
        if (!timeframe.isValid) {
          isValid = true
        }
      })
      if (this.timeframes.length == 0) {
        isValid = false
      }
      this.validRange = isValid
    },
  },
}
</script>
